import React, { Component } from 'react';
import { connect } from 'react-redux';

import ComponenteResumoDaCompra from './ComponenteResumoDaCompra';
import './header.scss';

import { APP_PAGES } from '../../routes';
import { withRouter } from 'react-router-dom';
import setaCima from '../../assets/icons/chevron-up.svg';
import setaBaixo from '../../assets/icons/chevron-down.svg';
import { Stepper } from 'veloe-ds';

export function getStep(page) {
  switch (page) {
    case APP_PAGES.CADASTRO:
      return 1;
    case APP_PAGES.RECEBER_PRODUTO:
    case APP_PAGES.QTD_PRODUTO:
    case APP_PAGES.ONDE_RECEBER_ADESIVO:
    case APP_PAGES.DADOS_VEICULO:
    case APP_PAGES.ONDE_USAR:
      return 2;
    case APP_PAGES.ONDE_RECEBER:
    case APP_PAGES.ENDERECO:
      return 3;
    case APP_PAGES.TIPO_PAGAMENTO:
    case APP_PAGES.RECARGA_AUTOMATICA:
    case APP_PAGES.REVISE_COMPRA:
    case APP_PAGES.FORMA_PAGAMENTO:
      return 4;
    default:
      return 0;
  }
}
/**
 * Agrupa as informções do fluxo de compras no header de acordo com o step
 *
 * */

export function achaCaminho() {
  return window.location.hash.replace('#', '');
}
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerOpen: false,
    };
  }

  abreHeader = () => {
    this.setState({ headerOpen: true });
  };

  fechaHeader = () => {
    this.setState({ headerOpen: false });
  };

  chamaFuncRand = () => {
    this.setState({ headerOpen: false });
    this.props.history.goBack();
  };

  render() {
    const { headerOpen } = this.state;
    const { dadosUsuario } = this.props.pedido;
    if (
      JSON.parse(localStorage.getItem('proposta')) === null ||
      JSON.parse(localStorage.getItem('proposta')) === ''
    ) {
      dadosUsuario.email = '';
      dadosUsuario.nomeCompleto = '';
    }
    const id = achaCaminho();
    const step = getStep(id);
    const steps = [1, 2, 3, 4];
    const label = [
      'Identificação',
      'Configuração Veloe',
      'Entrega',
      'Pagamento',
    ];

    return (
      <div className="containerHeader">
        {step >= 1 && (
          <div className="containerHeaderSuperior">
            <div className="containerHeaderInfosUser">
              {step >= 2 && (
                <>
                  <img
                    src={require('../../assets/back.png')}
                    alt="voltar"
                    id="click-voltar"
                    onClick={this.chamaFuncRand}
                  />

                  <div className="containerHeaderDadosUsu">
                    <label className="lblTituloComponenteHeader">
                      {dadosUsuario.nomeCompleto}
                    </label>
                    <label className="lblTextoComponenteHeader">
                      {dadosUsuario.email}
                    </label>
                  </div>
                </>
              )}
            </div>

            <div className="containerHeaderResume">
              {step >= 1 && (
                <div className="containerComponenteResumo">
                  <div className="containerTextComponenteResumo">
                    <label className="lblTituloComponenteResumo">Resumo</label>
                    <div className="lblTextoComponenteResumo">
                      <label className="lblTextoDescrResumo">Passo</label>
                      <label className="lblStep"> {step}/4</label>
                    </div>
                  </div>
                  {step >= 2 && (
                    <>
                      {headerOpen ? (
                        <img
                          className="seta-cima"
                          id="fecha-header"
                          src={setaCima}
                          alt=""
                          onClick={this.fechaHeader}
                        />
                      ) : (
                        <img
                          className="seta-baixo"
                          id="abre-header"
                          src={setaBaixo}
                          alt=""
                          onClick={this.abreHeader}
                        />
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {headerOpen && (
          <div className="containerHeaderInferior">
            <Stepper
              {...{
                steps,
                label,
                activeStep: step - 1,
                onBg: 'dark',
              }}
            />
            {<ComponenteResumoDaCompra />}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

export default withRouter(connect(mapStateToProps)(Header));
